import type { MessageDescriptor } from '@lingui/core';
import { useLingui } from '@lingui/react';
import { useEffect } from 'react';
import { useMatches } from 'react-router';

export type MetaResolver = (args: { msg: MessageDescriptor }) => {
  title?: MessageDescriptor;
  meta?: { name?: string; content: string }[];
};

export function HeadManager() {
  const { i18n } = useLingui();
  const matches = useMatches();

  useEffect(() => {
    let title: string | undefined;
    const metas: { name?: string; content: string }[] = [];

    for (const match of matches) {
      const resolver =
        match.handle && typeof match.handle === 'object' ? ('meta' in match.handle ? match.handle.meta : undefined) : undefined;
      if (typeof resolver !== 'function') continue;

      const resolved = resolver() as { title?: MessageDescriptor; meta?: { name?: string; content: string }[] };

      if (resolved.title) {
        title = i18n._(resolved.title);
      }

      if (resolved.meta) {
        for (const m of resolved.meta) {
          metas.push({
            name: m.name,
            content: m.content,
          });
        }
      }
    }

    if (title) document.title = title;

    document.querySelectorAll('meta[data-managed]').forEach((el) => {
      el.remove();
    });

    for (const m of metas) {
      const el = document.createElement('meta');
      if (m.name) el.setAttribute('name', m.name);
      el.setAttribute('content', m.content);
      el.setAttribute('data-managed', 'true');
      document.head.appendChild(el);
    }
  }, [matches, i18n]);

  return null;
}
